var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07849 8.48474C6.2833 8.48474 5.63867 9.12937 5.63867 9.92457C5.63867 10.7198 6.2833 11.3644 7.07849 11.3644H15.0422C15.8374 11.3644 16.482 10.7198 16.482 9.92457C16.482 9.12937 15.8374 8.48474 15.0422 8.48474H7.07849ZM7.07849 13.3332C6.2833 13.3332 5.63867 13.9779 5.63867 14.7731C5.63867 15.5682 6.2833 16.2129 7.07849 16.2129H15.0422C15.8374 16.2129 16.482 15.5682 16.482 14.7731C16.482 13.9779 15.8374 13.3332 15.0422 13.3332H7.07849Z",
    fill: "#FCAD09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.042 4.3562H7.07831C6.68071 4.3562 6.3584 4.67852 6.3584 5.07611C6.3584 5.47371 6.68071 5.79602 7.07831 5.79602H15.042C15.4396 5.79602 15.7619 5.47371 15.7619 5.07611C15.7619 4.67852 15.4396 4.3562 15.042 4.3562Z",
    fill: "#FCAD09",
    stroke: "#FCAD09",
    strokeWidth: 1.43982
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03606 6.52779C3.7547 6.52779 4.33726 5.88049 4.33726 5.08201C4.33726 4.28353 3.7547 3.63623 3.03606 3.63623C2.31743 3.63623 1.73486 4.28353 1.73486 5.08201C1.73486 5.88049 2.31743 6.52779 3.03606 6.52779Z",
    fill: "#FCAD09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03606 11.3764C3.7547 11.3764 4.33726 10.7291 4.33726 9.93064C4.33726 9.13216 3.7547 8.48486 3.03606 8.48486C2.31743 8.48486 1.73486 9.13216 1.73486 9.93064C1.73486 10.7291 2.31743 11.3764 3.03606 11.3764Z",
    fill: "#FCAD09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03606 16.2249C3.7547 16.2249 4.33726 15.5776 4.33726 14.7792C4.33726 13.9807 3.7547 13.3334 3.03606 13.3334C2.31743 13.3334 1.73486 13.9807 1.73486 14.7792C1.73486 15.5776 2.31743 16.2249 3.03606 16.2249Z",
    fill: "#FCAD09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogActive);
export default __webpack_public_path__ + "static/media/log_active.73446b70ef66b791533af8cd8c38dcdd.svg";
export { ForwardRef as ReactComponent };